<template>
  <div :class="menuClass" ref="contextMenu">
    <div v-if="hasHeader" class="header">{{ header }}</div>
    <div class="items" ref="items">
      <div class="menu-item" @click="itemClick(i)" v-for="i in menuItems" :key="i">
        <span>{{ i }}</span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  props: {
    left: { type: Number, default: 0 },
    top: { type: Number, default: 0 },
    show: { type: Boolean, default: false },
    hasHeader: { type: Boolean, default: false },
    header: { type: String, default: 'Header' },
    menuClass: { type: String, default: 'main-context hide' },
    menuItems: { type: Array, default: function() { return [
      'Item 1', 'Item 2 Is Very Long Right Here', 'Item 3', 'Item 4', 'Item 5', 'Item 1', 'Item 2 Is Very Long Right Here', 'Item 3', 'Item 4', 'Item 5', 
    ]; }}
  },
  watch: {
    left: function(val) {
      var leftpx = 0;

      if (val + 300 >= window.innerWidth) {
        leftpx = val - 200;
      } else {
        leftpx = val;
      }

      this.$refs.contextMenu.style.left = leftpx + 'px';
      this.$refs.contextMenu.lastChild.style.borderBottom = 'none';
    },
    top: function(val) {
      var toppx = 0;

      alert(val + ' ' + window.innerHeight);

      if (val + 400 >= window.innerHeight) {
        alert('a');
        toppx = val - 300;
      } else {
        toppx = val;
      }

      this.$refs.contextMenu.style.top = toppx + 'px';      
    },
    show: function (val) {
      if (val == true) {
        this.$refs.contextMenu.style.zIndex = 9999;
        this.menuClass = 'main-context show';
      } else {
        this.menuClass = 'main-context hide';
        setTimeout(() => {
          this.$refs.contextMenu.style.zIndex = -9999;
        }, 100);
      }
    },
    hasHeader: function(val) {
      if (val == true) {
        this.$refs.items.style.top = '35px';
      } else {
        this.$refs.items.style.top = '0';
      }
    }
  },
  methods: {
    itemClick: function(item) {
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.main-context {
  position: absolute;
  width: 200px;
  max-height: 300px;
  background-color: rgba(255,255,255,0.95);
  border-radius: 10px;
  box-shadow: 0px 0px 10px -1px rgba(0,0,0,1);
  // padding: 10px 0;
  overflow: scroll;
  top: 0;
  left: 0;
  transition: opacity 0.1s;
}

.show {
  opacity: 1;
}

.hide {
  opacity: 0;
}

.items {
  position: relative;
  top: 0;
}

.menu-item {
  position: relative;
  padding: 5px 25px;
  // left: 0;
  border-bottom: 1px solid rgba(0,0,0,0.2);
  transition: $transition-time;
}

.menu-item:hover {
  background-color: rgba(0,0,255,0.5);
  cursor: pointer;
  // left: calc(200px - 100%);
}

.header {
  background-color: white;
  z-index: 1;
  position: fixed;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  height: 35px;
  width: 200px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 3px solid rgba(0,0,0,0.5);
  // box-shadow: 0px 0px 5px 0px black;
}
</style>